<template>
  <div class="col-1 scroll">
    <el-table :data="list" border size="mini" tooltip-effect="dark" highlight-current-row>
      <el-table-column label="操作" align="center" width="40">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <a href="javascript:void(0);"> <i class="el-icon-setting" /> </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="joinProject(scope.row)">加入项目</el-dropdown-item>
              <el-dropdown-item @click.native="recomend(scope.row)">推荐</el-dropdown-item>
              <el-dropdown-item @click.native="uploadCv(scope.row)">上传简历</el-dropdown-item>
              <el-dropdown-item @click.native="uploadReport(scope.row)">上传推荐报告</el-dropdown-item>
              <el-dropdown-item @click.native="genReport(scope.row)">生成推荐报告</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" width="40">
        <template slot-scope="scope">
          <a :id="scope.row._id" class="popper-btn p-relative" @click="showFiles(scope.row._id)">
            <i class="el-icon-document" />
          </a>
        </template>
      </el-table-column>
      <el-table-column label="时间" sortable="custom" width="120">
        <template slot-scope="scope">{{
          scope.row.updatedAt ? dateFormat(new Date(parseInt(scope.row.updatedAt, 10)), 'yyyy-mm-dd HH:MM') : ''
        }}</template>
      </el-table-column>
      <el-table-column label="姓名" width="60">
        <template slot-scope="scope">
          <a href="javascript:void(0);" @click="showRadish(scope.row.rid || scope.row._id)">{{ scope.row['姓名'] }}</a>
        </template>
      </el-table-column>
      <el-table-column label="曾任职公司" show-overflow-tooltip min-width="100">
        <template slot-scope="scope">{{ scope.row['曾任职公司'] }}</template>
      </el-table-column>
      <el-table-column label="公司" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">{{ scope.row['公司'] }}</template>
      </el-table-column>
      <el-table-column label="部门" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">{{ scope.row['部门'] }}</template>
      </el-table-column>
      <el-table-column label="目前职位" show-overflow-tooltip width="80">
        <template slot-scope="scope">{{ scope.row['目前职位'] }}</template>
      </el-table-column>
      <el-table-column label="专业职级" show-overflow-tooltip width="80">
        <template slot-scope="scope">{{ scope.row['专业职级'] }}</template>
      </el-table-column>
      <el-table-column label="管理职级" show-overflow-tooltip width="80">
        <template slot-scope="scope">{{ scope.row['管理职级'] }}</template>
      </el-table-column>
      <el-table-column label="固薪" show-overflow-tooltip width="80">
        <template slot-scope="scope">{{ scope.row['固薪'] }}</template>
      </el-table-column>
      <el-table-column label="奖金" show-overflow-tooltip width="80">
        <template slot-scope="scope">{{ scope.row['奖金'] }}</template>
      </el-table-column>
      <el-table-column label="手机" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['手机'] }}</template>
      </el-table-column>
      <el-table-column label="其他" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['其他'] }}</template>
      </el-table-column>
      <el-table-column label="座机" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['座机'] }}</template>
      </el-table-column>
      <el-table-column label="邮箱" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['邮箱'] }}</template>
      </el-table-column>
      <el-table-column label="地域" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['地域'] && scope.row['地域'].toString() }}</template>
      </el-table-column>
      <el-table-column label="性别" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['性别'] }}</template>
      </el-table-column>
      <el-table-column label="行业" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ scope.row['行业'] }}</template>
      </el-table-column>
      <el-table-column v-if="handleRemove" label="删" align="center" width="40">
        <template slot-scope="scope">
          <a href="javascript:void(0);" class="ft-danger" @click="handleRemove(scope.row)">
            <i class="el-icon-delete" />
          </a>
        </template>
      </el-table-column>
    </el-table>
    <Popper id="drawerPopper" :visible.sync="popperVisible" :target-id="popperTarget" class-name="shadow">
      <FileTable :rid="rid" :files="files" :paginate="false" width="700px" />
    </Popper>
  </div>
</template>

<script>
import { FileTable } from '../../../file'
import Popper from './Popper.vue'

const dateFormat = require('dateformat')

export default {
  components: {
    Popper,
    FileTable,
  },
  props: {
    list: { type: Array, default: () => [] },
    handleRemove: { type: Function, default: undefined },
  },
  data() {
    return {
      popperVisible: false,
      files: [],
      popperTarget: '',
      rid: '',
    }
  },
  computed: {
    radishList() {
      return app.root.$refs.main.$refs.radishList
    },
    radishDetailTab() {
      return app.root.$refs.radishDetailTab
    },
    dateFormat() {
      return dateFormat
    },
  },
  methods: {
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    openList() {
      const { list } = this
      if (list.length === 0) {
        this.$message('无内容')
        return
      }
      try {
        const ids = list.map(v => v._id)
        this.radishList.query = {
          _id: ids,
        }
        this.radishList.loadData()
      } catch (error) {
        console.error(error)
      }
      this.collapsed = true
    },
    joinProject(row) {
      this.radishList.currentRow = row
      this.radishList.showIntoProject(false)
    },
    recomend(row) {
      this.radishList.currentRow = row
      this.radishList.showRecommend(false)
    },
    uploadCv(row) {
      this.radishList.currentRow = row
      this.radishList.uploadCv()
    },
    uploadReport(row) {
      this.radishList.currentRow = row
      this.radishList.uploadReport()
    },
    genReport(row) {
      app.root.$refs.reportMaker.init({ radish: row.rid || row._id })
    },
    async showFiles(rid) {
      const { data } = await window.app.service('file').radishFiles({
        query: { rid },
      })
      this.rid = rid
      this.files = data
      this.popperTarget = `${rid}`
      this.popperVisible = true
    },
  },
}
</script>
